import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChildTag, ContentCard, ShortCallContent } from '@omni/classes/short-call/short-call.class';

@Component({
  selector: 'io-content-cards',
  templateUrl: './io-content-cards.component.html',
  styleUrls: ['./io-content-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IoContentCardsComponent {

  @Input() contentData: ShortCallContent;
  @Output() selectedContent = new EventEmitter<ContentCard>();

  constructor() {

  }

  public onContentSelect(card: ContentCard) {
    this.selectedContent.emit(card);
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackByCardName(index: number, card: ContentCard): string {
    return card.contentId;
  }

  trackByTagName(index: number, tag: ChildTag): string {
    return tag.indskr_usertagid;
  }
}
